<template>
  <div class="transaction-list-widget-editor">
    <controller-section title="Position" :start-visible="true">
      <x-y-axis-widget-controllers @update="updateModel" :enable-x="false" :values="values"></x-y-axis-widget-controllers>
    </controller-section>
    <controller-section title="Layout">
      <div class="control-row">
        <controller field-name="zIndex" :value="values.zIndex" prepend="Z" @input="updateModel" append=""></controller>
      </div>
    </controller-section>
    <controller-section title="TransactionList">
      <div class="control-row">
        <controller field-name="pageNumber" :value="values.pageNumber" append="" input-type="number" @input="updateModel"></controller>
      </div>
      <div class="control-row">
        <controller field-name="numTransactionsInPage" :value="values.numTransactionsInPage" append="" input-type="number" @input="updateModel" />
      </div>
      <div class="control-row">
        <controller field-name="numPages" :value="values.numPages" append="" input-type="number" @input="updateModel" />
      </div>
      <div class="control-row">
        <controller field-name="transactions" :value="values.transactions" append="" input-type="text" @input="updateModel" />
      </div>
      <div class="control-row">
        <controller field-name="transactionsSum" :value="values.transactionsSum" append="" input-type="text" @input="updateModel" />
      </div>
    </controller-section>

    <controller-section title="Style">
    </controller-section>
  </div>
</template>
<script>
import Controller from '../Controller.vue';
import ControllerSection from '../ControllerSection.vue';
import XYAxisWidgetControllers from '../XYAxisWidgetControllers.vue';

export default {
  name: 'TransactionListWidgetEditor',
  components: {
    ControllerSection,
    Controller,
    XYAxisWidgetControllers,
  },
  props: {
    values: {},
  },
  computed: {
    availableFonts() {
      return ['SimplerPro', 'SimplerProBold', 'PauzaBold'];
    },
  },
  methods: {
    updateModel(field, value) {
      this.$emit('update', field, value);
    },
    rollValue(field, values, event) {
      const currentIndex = _.indexOf(values, this.values[field]);
      const newValue = values[_getValueBetween(0, currentIndex + _getIndexChange(event.code), values.length - 1)];
      this.updateModel(field, newValue);
    },
  },
};

function _getIndexChange(keypress) {
  if (keypress === 'ArrowLeft') {
    return -1;
  }
  if (keypress === 'ArrowRight') {
    return 1;
  }
  return 0;
}

function _getValueBetween(min, value, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

$button_radius: 4px;

.transaction-list-widget-editor {
  .control-row {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    &:first-of-type {
      margin-top: 0px;
    }
    align-items: center;
    &.text-row {
      margin-bottom: 15px;
      &::v-deep .control input {
        text-align: right;
        direction: rtl;
      }
    }
    div {
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }
  .button-row {
    border-radius: $button_radius;
    background-color: $riseup_gray_0;
    color: $riseup_black;
    .button {
      width: 100%;
      padding: 2px 0;
      text-align: center;
      &.selected {
        background-color: $riseup_light_blue;
        color: $riseup_white;
      }
      &:first-of-type {
        border-radius: $button_radius 0 0 $button_radius;
      }
      &:last-of-type {
        border-radius: 0 $button_radius $button_radius 0;
      }
    }
  }
}
</style>
